/* eslint-disable @angular-eslint/no-host-metadata-property */
import { CdkStepHeader, StepState } from '@angular/cdk/stepper';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NStepLabelDirective } from './n-step-label.directive';

@Component({
  selector: 'n-step-header',
  templateUrl: 'n-step-header.component.html',
  host: {
    class: 'n-step-header d-flex align-items-center',
    role: 'tab',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NStepHeaderComponent extends CdkStepHeader {
  /** State of the given step. */
  @Input() state: StepState;

  /** Label of the given step. */
  @Input() label: NStepLabelDirective | string;

  /** Error message to display when there's an error. */
  @Input() errorMessage: string;

  /** Index of the given step. */
  @Input() index: number;

  /** Whether the given step is selected. */
  @Input() selected: boolean;

  /** Whether the given step label is active. */
  @Input() active: boolean;

  /** Whether the given step is optional. */
  @Input() optional: boolean;

  /** Returns string label of given step if it is a text label. */
  stringLabel(): string | null {
    return this.label instanceof NStepLabelDirective ? null : this.label;
  }

  /** Returns NStepLabelDirective if the label of given step is a template label. */
  templateLabel(): NStepLabelDirective | null {
    return this.label instanceof NStepLabelDirective ? this.label : null;
  }
}
